/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import Icon from '@ant-design/icons';

const ZendeskSvg = () => (
  <svg width="1.1em" height="1.1em" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.00484 3.14078V10.5H0L6.00484 3.14078ZM6.00484 0.5C6.00484 2.18264 4.66013 3.54757 3.00242 3.54757C1.34471 3.54757 0 2.18264 0 0.5H6.00484ZM6.99516 10.5C6.99516 8.81568 8.33822 7.45243 9.99758 7.45243C11.6569 7.45243 13 8.81736 13 10.5H6.99516ZM6.99516 7.85754V0.5H13L6.99516 7.85754Z" fill="currentColor"/>
  </svg>
);

export const ZendeskIcon = (props) => (
  <Icon component={ZendeskSvg} {...props} />
);
